// @TODO: implement bundle splitting here for pym
import { Parent } from "pym.js";

export const handleEmbed = (block) => {
  const { oembed, type } = block.data;
  switch (type) {
    case "facebook-post":
    case "facebook-video": {
      let FB = window.FB;
      if (FB) {
        const element = document.querySelector(`.block-${block.key}`);
        FB.XFBML.parse(element);
      }
      break;
    }
    case "twitter": {
      let twttr = window.twttr;
      if (twttr) twttr.widgets.load();
      break;
    }
    case "jwplayer-video":
      new Parent(oembed.html_id, oembed.embed_url);
      break;
    case "axios-visual":
      if (oembed.slug && oembed.url) new Parent(oembed.slug, oembed.url);
      break;
    default:
      break;
  }
};



// WEBPACK FOOTER //
// ./src/utils/embed.js